module.exports = __webpack_public_path__ + "static/chirurgia-palca-image-1-1fe2877e3a5348f9a99a3ceb9dde0405.png";